import { ModalProps, ModalService } from '@philips-internal/oswald-ui-components';
import { ModalType } from '@philips-internal/oswald-ui-constants';
import {  } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID } from '@philips-internal/oswald-ui-utils';

export interface AdminScheduleFractionalDoseProps {
  barcodeClose: () => void;
  currentBarcode: string;
  currentDoseQuantity?: number;
  medicationOrSolution: string;
  prescriptionNumber: number;
  prescriptionType?: string;
  scheduleDate?: string;
  scheduleSequenceNumber?: number;
  solutionSequenceNumber?: number;
  stepSolutionNumber?: number;
  unitMeasureDoseDescription?: string;
  updatedCards: () => void;
}

export class AdminModalsFractionalDoseService {

  public static modalAdminScheduleFractionalDose({
    barcodeClose,
    currentBarcode,
    medicationOrSolution,
    prescriptionType,
    prescriptionNumber,
    scheduleDate,
    scheduleSequenceNumber,
    solutionSequenceNumber,
    stepSolutionNumber,
    unitMeasureDoseDescription,
    updatedCards
  }: AdminScheduleFractionalDoseProps): void {
    const dialogModal: ModalProps = {
      closeByDocument: false,
      closeByEscape: false,
      contextData: {
        barcodeClose,
        currentBarcode,
        medicationOrSolution,
        prescriptionNumber,
        prescriptionType,
        scheduleDate,
        scheduleSequenceNumber,
        solutionSequenceNumber,
        stepSolutionNumber,
        unitMeasureDoseDescription,
        updatedCards
      },
      focusOnOpen: false,
      fragment: 'administration-schedule-fractional-dose',
      id: 'adm-schedule-fractional-dose',
      onBeforeClose: () => updatedCards(),
      title: 'text.inform-the-dose-of-the-drug',
      type: ModalType.DEFAULT,
      uuid: generateUUID(),
    };

    ModalService.openDefault(dialogModal);
  }
}
